import { createTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface TypeBackground {
    stepper?: string
    canvas?: string
    errorContainer?: string
    accentPink?: string
    chip?: string
    activeTab?: string
    disableTab?: string
  }
  interface TypeText {
    stepper?: string
  }
}

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#68cea1',
    },
    success: {
      main: '#68cea1',
    },
    warning: {
      main: '#ffb975',
    },
    info: {
      main: '#2b66f6',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#D9D9D9',
      stepper: '#54575f',
    },
    background: {
      default: '#000000',
      paper: '#121315',
      stepper: '#54575f',
      canvas: '#252525',
      errorContainer: '#F9DEDC',
      accentPink: '#FF5C88',
      chip: '#FF91A4',
      activeTab: '#557289',
      disableTab: '#292929',
    },
    action: {
      disabled: '#4f4f4f',
      text: '#D9D9D9',
      hover: alpha('#ffffff', 0.08),
      selected: alpha('#90caf9', 0.16),
      enabled: '#999999',
    },
    error: {
      main: '#e46962',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#000000',
          color: '#FFFFFF',
          '--color-text-primary': '#FFFFFF',
          '--color-text-secondary': '#D9D9D9',
          '--color-text-dark-primary': '#000000',
          '--color-text-dark-secondary': '#303030',
          '--color-border-fields': '#999999',
          '--color-border-table': '#808080',
          '--color-accent-primary': '#90caf9',
          '--color-accent-green': '#68cea1',
          '--color-accent-pink': '#ff5c88',
          '--color-accent-blue': '#2b66f6',
          '--color-accent-orange': '#ffb975',
          '--color-accent-peach': '#ff9dbf',
          '--color-accent-gray': '#8e8e93',
          '--color-accent-neongreen': '#00e68a',
          '--color-accent-neonblue': '#00dee6',
        },
        '*::-webkit-scrollbar': {
          width: '8px !important',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#ffb572 !important',
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: '#212121 !important',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#999',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#212121',
          fontSize: '12px',
          letterSpacing: '0.5px',
        },
        arrow: {
          color: '#212121',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: '0px',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#999999',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: '#292929',
          '& *::-webkit-scrollbar': {
            width: '8px !important',
          },
          '& *::-webkit-scrollbar-thumb': {
            backgroundColor: '#ffb572 !important',
            borderRadius: '0px !important',
          },
          '& *::-webkit-scrollbar-track': {
            backgroundColor: '#212121 !important',
          },
        },
      },
    },
    // MuiModal: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: '#292929',
    //     },
    //   },
    // },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          '&.Mui-selected': {
            backgroundColor: alpha('#90caf9', 0.16),
            color: '#90caf9',
            '&:hover': {
              backgroundColor: alpha('#90caf9', 0.24),
            },
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor:
            'linear-gradient(rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), rgb(18, 18, 18)',
          borderRadius: '4px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
        },
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: alpha('#ffffff', 0.08),
          },
          '&.Mui-selected': {
            backgroundColor: alpha('#ffffff', 0.16),
            color: '#ffffff',
            '&:hover': {
              backgroundColor: alpha('#ffffff', 0.24),
            },
          },
        },
      },
    },
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //       flex: 1,
    //       '& input': {
    //         textAlign: 'center',
    //         color: 'FFFFFF',
    //         padding: '0.282rem',
    //       },
    //       '& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button':
    //         {
    //           opacity: 1,
    //           display: 'block',
    //         },
    //       '&:hover .MuiOutlinedInput-notchedOutline': {
    //         borderColor: '#4f4f4f',
    //       },
    //     },
    //   },
    // },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
})

// Add a konva property to the theme to prevent React-Konva from trying to modify it
Object.defineProperty(theme, 'konva', {
  value: {},
  writable: false,
  configurable: false,
})

export default theme
